export const ApiDef_PermissionDomain = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map